export default __webpack_public_path__ + "static/media/back.a47eb7b0.svg";